import { render, staticRenderFns } from "./CheckoutVipOrderConfirmation.vue?vue&type=template&id=284e0fc2&scoped=true"
import script from "./CheckoutVipOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./CheckoutVipOrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutVipOrderConfirmation.vue?vue&type=style&index=0&id=284e0fc2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e0fc2",
  null
  
)

export default component.exports